export default {
	plural: (singular, plural, num) => {
		try {
			if (String(num).endsWith('1') && num != 11) {
				return singular;
			}
			else {
				return plural;
			}
		}
		catch (e) {
			return plural;
		}
	}
}



// WEBPACK FOOTER //
// ./src/helpers.js